// import { odsTokens } from 'kfone-component-library';
import { odsTokens } from 'kfone-component-library/odsTokens';

// export const ChartColors = {
//   GENDER_CHART: {
//     MALE: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color6'],
//     FEMALE: odsTokens.colors['ods-color-dataviz-categorical-color11'],
//     OHTER: odsTokens.colors['ods-color-dataviz-categorical-color10'],
//   },
//   RACE_ETHNICITY_CHART: {
//     WHITE: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color1'],
//     NON_WHITE: odsTokens.colors['ods-color-dataviz-divergent-orange-teal-color9'],
//     BLACK: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color3'],
//     HISPANIC: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color5'],
//     ASIAN: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color6'],
//     OTHER: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color8'],
//     MORE: odsTokens.colors['ods-color-dataviz-sequential-blue-yellow-color9'],
//   },
// };

export const ChartColors = {
  GENDER_CHART: {
    MALE: '#00BC99',
    FEMALE: '#9A299D',
    OHTER: '#E2A3FF',
  },
  RACE_ETHNICITY_CHART: {
    WHITE: '#002F61',
    NON_WHITE: '#8073AC',
    BLACK: '#006C8E',
    HISPANIC: '#00A29D',
    ASIAN: '#8073AC',
    OTHER: '#4DEB6D',
    MORE: '#9BF848',
  },
};
